import apiFetch from '../apiFetch'

export default function (token, signType) {
  return apiFetch({ endPoint: 'SignType', method: 'PUT', body: signType, token: token })
}
